/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { STATUS_EXTRAJUDICIAL_COMMUNICATION_SENT } from "../leadStatus";
import { Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { HashLink, HashLink as Link } from "react-router-hash-link";
import { getCaseLink } from "../../productService";
import React from "react";

export const ExtraContent = ({ litigationCase }: { litigationCase: AbstractCase }) => {
  //both buttons in here because otherwise we cant produce the break line between both texts parts in the first text block
  if (litigationCase.leadStatus === STATUS_EXTRAJUDICIAL_COMMUNICATION_SENT) {
    return (
      <Stack spacing={3} sx={{ marginTop: 2 }}>
        <Typography>
          Es kam inzwischen zu einer Einigung mit der Gegenseite und der Fall kann abgeschlossen werden? Dann teilen Sie uns dies bitte hier kurz mit:
        </Typography>
        <Button component={Link} to={getCaseLink(litigationCase) + "/abschliessen"} variant="contained" color="primary" fullWidth>
          Fall abschließen
        </Button>
        <Typography>Sie haben eine nicht zufriedenstellende Reaktion der Gegenseite erhalten? Dann laden Sie uns diese bitte hoch:</Typography>
        <Button component={HashLink} to={getCaseLink(litigationCase) + "#upload"} variant="contained" color="primary" fullWidth>
          Dokument hochladen
        </Button>
      </Stack>
    );
  }

  return null;
};
